export type SiteConfig = {
  name: string;
  description: string;
  url: string;
  apiUrl: string;
  stagingApiUrl: string;
};

export const siteConfig: SiteConfig = {
  name: "Decoda Health",
  description:
    "Decoda Health centralizes communications between healthcare clinics and patients along with a comprehensive payments platform. Our platform makes it easy for patients to communicate with their healthcare providers and pay for services all in one place.",
  url: "https://decodahealth.com",
  apiUrl: "https://api.decodahealth.com",
  stagingApiUrl: "https://api.staging.decodahealth.com",
};
